import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
//import "./assets/scss/base.scss";
import axios from 'axios'
import VueI18n from 'vue-i18n'
// import plugin
import messages from './plugins/i18n'
// import filtros
import './plugins/filters'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// google analitycs
import VueGtag from 'vue-gtag'
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'G-WCMY18QQ4V',
//   router,
// })
Vue.use(
  VueGtag,
  {
    config: { id: 'G-WCMY18QQ4V' },
  },
  router
)
Vue.use(VueI18n)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'es', // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
})

Vue.config.productionTip = false
//axios.defaults.baseURL = 'https://apiway.lubumas.com/api/';
axios.defaults.baseURL = 'http://localhost:5002/api/'
//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// use this package's plugin
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md',
})

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
